import { useQueryClient } from "@tanstack/react-query";

export const customerKey = (customerId?: string | null) =>
  ["customer", customerId] as const;
export const customersKey = (businessId?: string | null, withPayouts = false) =>
  ["customers", businessId, withPayouts] as const;
export const customersV2BaseKey = (businessId?: string | null) =>
  ["customers-v2", businessId] as const;
export const customersV2Key = (
  businessId?: string | null,
  {
    customerType = "all",
    sortBy = "created_at",
    sortDirection = "desc",
    search = "",
    pageSize = 50,
    withPayouts = false,
    withReferrals = false,
  }: {
    customerType?: "all" | "leads" | "advocates";
    sortBy?: "created_at" | "name" | "referrals_count" | "payouts_total";
    sortDirection?: "asc" | "desc";
    search?: string;
    pageSize?: number;
    withPayouts?: boolean;
    withReferrals?: boolean;
  } = {},
) =>
  [
    ...customersV2BaseKey(businessId),
    customerType,
    sortBy,
    sortDirection,
    search,
    pageSize,
    withPayouts,
    withReferrals,
  ] as const;
export const customerNotesKey = (customerId: string) =>
  ["customer-notes", customerId] as const;

export const invalidateCustomerQueries = (
  queryClient: ReturnType<typeof useQueryClient>,
  businessId?: string | null,
) => {
  void queryClient.invalidateQueries({ queryKey: customersKey(businessId) });
  void queryClient.invalidateQueries({
    queryKey: customersV2BaseKey(businessId),
  });
};
